module.exports = __webpack_public_path__ + "img/card-number-input-light.83444b1e.svg";